export const GET_POOL_REQUEST_INBOX_SUCCESS = 'GET_POOL_REQUEST_INBOX_SUCCESS';

export const getPoolRequestInboxSuccess = ({ poolRequestInboxCount, request }) => ({
    type: GET_POOL_REQUEST_INBOX_SUCCESS,
    payload: { poolRequestInboxCount },
    meta: {
        request,
    }
});
